exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.notifications-table[data-v-2b564b50] {\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n}\n", ""]);

// exports
